import { UiService } from './../../../shared/services/ui/ui.service';
import { ClubService } from './../../../shared/services/club/club.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  clubCode: string;
}

@Component({
  selector: 'app-open-dialog-legal-notices',
  templateUrl: './open-dialog-legal-notices.component.html',
  styleUrls: ['./open-dialog-legal-notices.component.scss']
})
export class OpenDialogLegalNoticesComponent implements OnInit {
  editorConfigQuote: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Mentions légales pour le devis',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo'
      ],
      ['fontSize']
    ],
  };

  editorConfigInvoice: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Mentions légales pour la facture',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo'
      ],
      ['fontSize']
    ],
  };

  legalNoticesForm: UntypedFormGroup;
  legalNotices: any;

  isLoading = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogLegalNoticesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private clubSrv: ClubService,
    private uiSrv: UiService
  ) { }

  ngOnInit(): void {
    this.initSubscription();
  }

  initSubscription(): void {
    this.isLoading = true;
    this.clubSrv.getLegalNoticesByClub(this.data.clubCode).subscribe(legalNotices => {
      this.legalNotices = legalNotices;
      this.isLoading = false;
      this.initForm();
    });
  }

  private initForm(): void {
    let legalNoticeQuote = '';
    let legalNoticeInvoice = '';

    if (this.legalNotices) {
      legalNoticeQuote = this.legalNotices.legalNoticeQuote;
      legalNoticeInvoice = this.legalNotices.legalNoticeInvoice;
    }

    this.legalNoticesForm = this.formBuilder.group({
      clubCode: this.data.clubCode,
      legalNoticeQuote: [legalNoticeQuote],
      legalNoticeInvoice: [legalNoticeInvoice]
    });
  }

  onSubmit(): void {
    this.clubSrv.updateLegalNotices(this.legalNoticesForm.value).subscribe(() => {
      this.uiSrv.showSnackbar('Mentions légales modifiées', false);
    });

    this.dialogRef.close();
  }

}
